import { styled } from '@material-ui/styles';
import { Button } from '@material-ui/core';

export default styled(Button)({
    background: '#77787B',
    border: '2px solid #00000',
    color: 'white',
    height: 42,
});
